import InfoGroupCard from './InfoGroupCard';

export default InfoGroupCard;
